export default __webpack_public_path__ + "static/media/dynamiser.85af01e5.svg";